var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-backtop',{staticClass:"backTop"},[_c('div',[(
          _vm.currentPath != '/service' &&
          _vm.currentPath != '/privacy' &&
          _vm.currentPath != '/aboutCaptcha'
        )?_c('ContactCode'):_vm._e(),_c('div',{staticClass:"backTop-btn"},[_c('img',{attrs:{"src":require("@/assets/images/zhiding.svg")}})])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }